import React from 'react';
import { isPartner } from 'src/helpers/isPartner';
import { RequestStatus } from 'src/components/AuthNew/types';
import { AuthSuccess } from 'src/components/AuthNew/components/AuthSuccess';
import { Link, Checkbox } from '@lt/components';
import { ButtonWithLoader } from 'src/components/AuthNew/components/ButtonWithLoader/ButtonWithLoader';
import type { FormikProps } from 'formik/dist/types';
import { Field } from 'formik';
import { useTranslation, Trans } from '@lt/localization';

import type { FormValues } from '../../types';
import { FormFields } from '../../types';
import { checkSubmitDisabled } from '../../helpers';
import styles from './footer.module.css';

type Props = {
  requestStatus?: RequestStatus;
} & FormikProps<FormValues>;

export const Footer = ({
  requestStatus,
  values,
  setFieldValue,
  isSubmitting,
}: Props) => {
  const { t } = useTranslation();

  return (
    <>
      {requestStatus !== RequestStatus.Succeeded && (
        <>
          <div className={styles.checkboxesWrapper}>
            <div>
              <Field
                component={StyledCheckbox}
                name={FormFields.AcceptProcessingPersonalData}
                checked={values.acceptProcessingPersonalData}
                onChange={() =>
                  setFieldValue(
                    FormFields.AcceptProcessingPersonalData,
                    !values.acceptProcessingPersonalData,
                  )
                }
              >
                <span>
                  <Trans
                    i18nKey="checkout.registrationForm.personalData"
                    components={{
                      Link: (
                        <Link
                          href={
                            isPartner('mosgortur') ||
                            isPartner('mosgortur_public')
                              ? '/articles/privacy_policy_consent_1297'
                              : '/articles/privacy_policy_consent'
                          }
                        />
                      ),
                    }}
                  />
                </span>
              </Field>
              <Field
                component={StyledCheckbox}
                name={FormFields.AcceptPromotions}
                checked={values.acceptPromotions}
                onChange={() =>
                  setFieldValue(
                    FormFields.AcceptPromotions,
                    !values.acceptPromotions,
                  )
                }
              >
                <Trans
                  i18nKey="checkout.registrationForm.acceptPromotions"
                  components={{
                    Link: (
                      <Link
                        href={
                          isPartner('mosgortur') ||
                          isPartner('mosgortur_public')
                            ? '/articles/advertising_1297'
                            : '/articles/advertising'
                        }
                      />
                    ),
                  }}
                />
              </Field>
            </div>
          </div>
          <ButtonWithLoader
            className={styles.buttonWithLoader}
            size="large"
            primary
            type="submit"
            isLoading={isSubmitting}
            disabled={isSubmitting || checkSubmitDisabled(values)}
            width="100%"
          >
            {t('checkout.registrationForm.button')}
          </ButtonWithLoader>
        </>
      )}
      {requestStatus === RequestStatus.Succeeded && <AuthSuccess />}
    </>
  );
};

const StyledCheckbox = ({ className, ...props }) => (
  <Checkbox className={className} {...props} />
);
